<template>
    <div class="decision-rationale-block" :class="{'decision-rationale-block-border': !valid}">
        <div v-if="!valid" class="text-xs-center pa-4 d-flex align-center">
            <div style="width: 100%;" class="decision-rationale-block-main">
                <div>
                    <div class="decision-rationale-block-title">Intervention Decision Rationale</div>
                    <span class="decision-rationale-block-subtitle">
                        Link an intervention to display. This field will not print unless an intervention is linked.
                    </span>
                </div>
                <fe-btn usage="secondary" 
                    @click="showLinkForm = true"
                    data-test="smartform-intervention-decision-rationale-link-intervention-btn"
                    role="button"
                    tabindex="0"
                    aria-label="Open link interventions"
                    @keydown.enter="showLinkForm = true"
                    @keydown.space.prevent="showLinkForm = true"
                >
                    <v-icon class="mr-2">fal fa-link</v-icon>Link Intervention
                </fe-btn>
            </div>
        </div>
        
        <div v-else class="ma-4">
            <div v-if="linkedToFormField">
                <div class="mb-2 align-center d-flex modal-title" style="font-size: 18px;">
                    {{ linkedToFormField.plan_name }}
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <fe-btn v-on="on" usage="secondary">
                                Update Decision Rationale <v-icon class="ml-2">fal fa-chevron-down</v-icon>
                            </fe-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="showLinkForm = true"
                                data-test="smartform-intervention-decision-rationale-select-new-intervention-btn"
                            >
                                Select Another Decision Rationale
                            </v-list-item>
                            <v-list-item @click="removeDecisionRationale()" 
                                style="color: #BF0D00;"
                                data-test="smartform-intervention-decision-rationale-remove-intervention-btn"
                            >
                                Remove Decision Rationale
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
            <message 
                dense
                :style="{ height: height ? height+'px' : undefined, }"
                :params="getParams"
                messageModel="interventionComments"
                :allowPrivate="false"
            />
        </div>

        <link-decision-rationale 
            ref="interventionLinkForm" 
            v-model="showLinkForm" 
            :formInstance="formInstance" 
            :fieldRec="fieldRec" 
            :linkedDecisionRationale="params.decisionRationales"
            @reload="onReload"
        />
    </div>
</template>

<script>
    import Message from '@/components/common/Message'
    import LinkDecisionRationale from './LinkDecisionRationale'

    export default {
        name: 'InterventionDecisionRationale',
        
        components: { Message, LinkDecisionRationale },
        
        props: ['fieldRec', 'height', 'editor', 'params', 'formInstance'],
        computed: {
            valid() {
                let intervention_id = this.linkedToFormField?.id
                return intervention_id && this.params?.student_id && this.linkedToFormField
            },
            getParams() {
                let intervention_id = this.linkedToFormField?.id
                const { decisionRationales, ...rest } = this.params
                rest.intervention_id = intervention_id
                return rest
            },
            linkedToFormField() {
                return this.params?.decisionRationales?.find(x => x.form_field_id === this.fieldRec?.form_field_id) || null
            }
        },
        data() {
            return {
                showLinkForm: false,
            }
        },
        methods: {
            async removeDecisionRationale() {
                let existing = await this.$refs?.interventionLinkForm?.getInterventions()
                let planToRemove = existing.find(x => x.intervention_id === this.linkedToFormField.id)
                if (planToRemove) this.$refs?.interventionLinkForm?.doUnlink(planToRemove)
            },
            onReload() {
                this.$emit('reloadInterventionLink')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .decision-rationale-block {
        justify-content: space-between;
        margin: 16px 0 16px 0;
        &-border {
            border: 1px solid #E0E1E6;
            border-radius: 4px;
        }
        &-title {
            font-size: 16px; 
            font-family: 'HyperlegibleSans-Medium', Hyperlegible Sans, 'Roboto', sans-serif;
        }
        &-subtitle {
            color: #495B8F;
        }
        &-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
    .modal-title {
        justify-content: space-between;
    }
</style>
